import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7637c6bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "InformationPanel view-default z-information-panel" }
const _hoisted_2 = { class: "Panel__Background__Inner bg-gradient" }
const _hoisted_3 = { class: "Exhibition" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "Exhibition__Footer" }
const _hoisted_6 = { class: "Exhibition__Cta" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "About" }
const _hoisted_9 = { class: "About__Content" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "Nav small-caps" }
const _hoisted_12 = { href: "javascript: Cookiebot.renew()" }

import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { gsap } from 'gsap'
import SimpleScrollbar from 'simple-scrollbar'
import SplitText from '@/utils/SplitText'
import { setFPS } from '@/utils/FrameToTime'
import ArtistName, { VARIANT as ArtistNameVariant } from '@/components/ArtistName/ArtistName.vue'
import Heading from '@/components/Heading/Heading.vue'
import Viewport from '@/store/modules/Viewport'
import informationPanel from '@/store/modules/InformationPanel'
import legalPage, { PAGES as LegalPages } from '@/store/modules/LegalPage'

import { VARIANT as UIBtnVariant } from '@/components/UIBtn/UIBtnPrimary.vue'
import Gtm from '@/utils/Gtm'


import { Component, defineComponent } from 'vue'

const __default__ = defineComponent({})

function setup(__props) {

const { locale } = useI18n()

const panel = ref<HTMLElement>(null)
const background = ref<HTMLElement>(null)
const inner = ref<HTMLElement>(null)
const date = ref<HTMLElement>(null)
const name = ref<typeof Heading>(null)
const title = ref<HTMLElement>(null)
const description = ref<HTMLElement>(null)
const footer = ref<HTMLElement>(null)

const showExhibitionBtn = ref(false)

const scroller = ref<HTMLElement>(null)
const watchScroller = () => {
  if (scroller.value) {
    SimpleScrollbar.unbindEl(scroller.value)
    Viewport.isDesktop && SimpleScrollbar.initEl(scroller.value)
  }
}
watch(() => Viewport.isDesktop, watchScroller)

onMounted(() => {
  watchScroller()
})
onBeforeUnmount(() => {
  scroller.value && SimpleScrollbar.unbindEl(scroller.value)
})
watch(locale, () => {
  date.value?.classList.remove('is-split')
  name.value?.$refs.inner.classList.remove('is-split')
  title.value?.classList.remove('is-split')
})

const frames = setFPS(60)

function onBeforeEnter(el: HTMLElement) {
  const $ = gsap.utils.selector(el)
  gsap.set(inner.value, { autoAlpha: 1 })
  gsap.set(el, { overflow: 'hidden' })
  gsap.set($('.ArtistName__Line'), { yPercent: 100 })
  gsap.set(description.value, { opacity: 0, y: 14 })
  gsap.set(footer.value, { autoAlpha: 0 })
}

function onEnter(el: HTMLElement, onComplete: GSAPCallback) {
  // reset scroll
  el.scrollTop = 0

  if (!date.value.classList.contains('is-split')) {
    // split twice for lines double wrapping
    new SplitText(date.value, { type: 'lines', linesClass: 'Line Exhibition__Date__Line' })
    new SplitText(date.value, { type: 'lines', linesClass: 'LineWrap Exhibition__Date__LineWrap' })
    date.value.classList.add('is-split')
  }
  if (!name.value.$refs.inner.classList.contains('is-split')) {
    // split twice for lines double wrapping
    new SplitText(name.value.$refs.inner, { type: 'lines', linesClass: 'Line Exhibition__Name__Line' })
    new SplitText(name.value.$refs.inner, { type: 'lines', linesClass: 'LineWrap Exhibition__Name__LineWrap' })
    name.value.$refs.inner.classList.add('is-split')
  }
  if (!title.value.classList.contains('is-split')) {
    // split twice for lines double wrapping
    new SplitText(title.value, { type: 'lines', linesClass: 'Line About__Title__Line' })
    new SplitText(title.value, { type: 'lines', linesClass: 'LineWrap About__Title__LineWrap' })
    title.value.classList.add('is-split')
  }

  const startFrame = 68

  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({
    defaults: {
      ease: 'linear'
    },
    onComplete
  })
  tl
    .fromTo(background.value, {
      y: Viewport.isDesktop ? '100%' : (Viewport.windowHeight - panel.value.offsetTop)
    }, {
      y: 0,
      duration: frames(116 - startFrame),
      ease: 'quint.inOut'
    })
    .to($('.ArtistName__Line'), {
      yPercent: 0,
      duration: frames(151 - 97),
      ease: 'quint.out',
      stagger: frames(8)
    }, frames(97 - startFrame))
    .from($('.Exhibition__Date__Line'), {
      yPercent: 100,
      duration: frames(153 - 129),
      ease: 'quart.out'
    }, frames(129 - startFrame))
    .addLabel('about', '<')
    .from($('.About__Title__Line'), {
      yPercent: 100,
      duration: frames(153 - 129),
      ease: 'quart.out'
    }, 'about')
    .from($('.Exhibition__Name__Line'), {
      yPercent: 100,
      duration: frames(165 - 145),
      ease: 'quint.out'
    }, frames(145 - startFrame))
    .to(description.value, {
      y: 0,
      duration: frames(200 - 129),
      ease: 'quint.out'
    }, 'about')
    .to(description.value, {
      opacity: 1,
      duration: frames(200 - 140)
    }, `<${frames(140 - 129)}`)
    .add(() => {
      showExhibitionBtn.value = true
    }, '<')
    .to(footer.value, {
      autoAlpha: 1,
      duration: frames(168 - 156),
    }, frames(156 - startFrame))
}

function onAfterEnter(el: HTMLElement) {
  gsap.set(el, { clearProps: 'overflow' })

  // force custom scrollbar to appear if exists
  if (scroller.value && Object.prototype.hasOwnProperty.call(scroller.value, 'data-simple-scrollbar')) {
    scroller.value['data-simple-scrollbar'].moveBar()
    scroller.value.classList.toggle('is-enabled', scroller.value['data-simple-scrollbar'].scrollRatio < 1)
  }
}

function onBeforeLeave(el: HTMLElement) {
  gsap.set(el, { overflow: 'hidden' })
}

function onLeave(el: HTMLElement, onComplete: GSAPCallback) {
  const tl = gsap.timeline({
    defaults: {
      ease: 'linear'
    },
    onComplete
  })
  tl
    .to([inner.value, footer.value], {
      autoAlpha: 0,
      duration: 0.3
    })
    .to(background.value, {
      y: Viewport.isDesktop ? '100%' : (Viewport.windowHeight - panel.value.offsetTop + el.scrollTop),
      duration: 0.8,
      ease: 'quint.inOut'
    }, .2)
}

function onAfterLeave(el: HTMLElement) {
  gsap.set(el, { clearProps: 'overflow' })
  scroller.value?.classList.remove('is-enabled')
  showExhibitionBtn.value = false
}

function onGetTickes() {
  Gtm.sendEventPush(
    'information',
    'buy-tickets',
    'Click on buy tickets'
  )
}

return (_ctx: any,_cache: any) => {
  const _component_inset_border = _resolveComponent("inset-border")!
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onBeforeEnter: onBeforeEnter,
    onEnter: onEnter,
    onAfterEnter: onAfterEnter,
    onBeforeLeave: onBeforeLeave,
    onLeave: onLeave,
    onAfterLeave: onAfterLeave
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "Backdrop",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(informationPanel).close()))
        }),
        _createElementVNode("div", {
          ref: (_value, _refs) => {
            _refs['panel'] = _value
            panel.value = _value
          },
          class: "Panel view-default__inner"
        }, [
          _createElementVNode("div", {
            ref: (_value, _refs) => {
              _refs['background'] = _value
              background.value = _value
            },
            class: "Panel__Background rounded-24"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_inset_border)
            ])
          ], 512),
          _createElementVNode("div", {
            ref: (_value, _refs) => {
              _refs['inner'] = _value
              inner.value = _value
            },
            class: "Panel__Inner"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(ArtistName, {
                class: "Exhibition__Artist",
                variant: _unref(ArtistNameVariant).GRADIENT
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    ref: (_value, _refs) => {
                      _refs['date'] = _value
                      date.value = _value
                    },
                    class: "Exhibition__Date small-caps",
                    innerHTML: _ctx.$t('about.exhibition_date')
                  }, null, 8, _hoisted_4)
                ]),
                _: 1
              }, 8, ["variant"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(Heading, {
                  key: _unref(locale),
                  ref: (_value, _refs) => {
                    _refs['name'] = _value
                    name.value = _value
                  },
                  class: "Exhibition__Name"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.exhibition_name')), 1)
                  ]),
                  _: 1
                }, 512),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("a", {
                    onClick: onGetTickes,
                    href: _ctx.$t('about.exhibition_ticket_link'),
                    target: "_blank"
                  }, [
                    _withDirectives(_createVNode(_component_ui_btn, {
                      variant: _unref(UIBtnVariant).OUTLINE
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('about.exhibition_cta')), 1)
                      ]),
                      _: 1
                    }, 8, ["variant"]), [
                      [_vShow, showExhibitionBtn.value]
                    ])
                  ], 8, _hoisted_7)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                ref: (_value, _refs) => {
                  _refs['scroller'] = _value
                  scroller.value = _value
                },
                class: "About__Inner"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    ref: (_value, _refs) => {
                      _refs['title'] = _value
                      title.value = _value
                    },
                    class: "About__Title small-caps"
                  }, _toDisplayString(_ctx.$t('about.title')), 513),
                  _createElementVNode("div", {
                    ref: (_value, _refs) => {
                      _refs['description'] = _value
                      description.value = _value
                    },
                    class: "About__Description text",
                    innerHTML: _ctx.$t('about.description')
                  }, null, 8, _hoisted_10)
                ])
              ], 512)
            ])
          ], 512),
          _createElementVNode("div", {
            ref: (_value, _refs) => {
              _refs['footer'] = _value
              footer.value = _value
            },
            class: "Panel__Footer"
          }, [
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#legals",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(legalPage).open(_unref(LegalPages).LEGALS)), ["prevent"]))
                }, _toDisplayString(_ctx.$t('about.nav.legals')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#credits",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(legalPage).open(_unref(LegalPages).CREDITS)), ["prevent"]))
                }, _toDisplayString(_ctx.$t('about.nav.credits')), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('about.nav.cookies')), 1)
              ])
            ])
          ], 512)
        ], 512)
      ])
    ]),
    _: 1
  }))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})